export var MenuList = [
    { link: '#information', textEn: 'information', textJp: 'お知らせ' },
    { link: '#about', textEn: 'about', textJp: 'BALLPARK FANTASIAについて' },
    { link: '#access', textEn: 'ACCESS', textJp: 'アクセス' }
];
